export const RISK_STATUS = {
  NEEDS_REVIEW: 'needs-review',
  REVIEWED: 'reviewed'
};
export const FLOW_TYPES = {
  ACTION_SET: 'actionset',
  WORKFLOW: 'workflow'
};